<template>
  <el-carousel
    indicator-position="inside"
    :interval="5000"
    trigger="click"
    class="carousel"
    arrow="never"
  >
    <el-carousel-item key="1">
      <div class="img img-1"></div>
    </el-carousel-item>
    <el-carousel-item key="2">
      <div class="img img-2"></div>
    </el-carousel-item>
    <el-carousel-item key="3">
      <div class="img img-3"></div>
    </el-carousel-item>
    <el-carousel-item key="4">
      <div class="img img-4"></div>
    </el-carousel-item>
    <el-carousel-item key="5">
      <div class="img img-5"></div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: 'Carousel'  
}
</script>

<style lang="scss">
.carousel {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 100;

  .el-carousel__container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .el-carousel__arrow {
    background: #0000dc;
  }

  .el-carousel__button {
    background: #0000dc;
    height: 15px;
    width: 40px;
    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.35);
    border-radius: 5px;
  }

  .img {
    position: relative;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .img-1 {
    background-image: url("../assets/1.jpg");
  }

  .img-2 {
    background-image: url("../assets/2.jpg");
  }

  .img-3 {
    background-image: url("../assets/3.jpg");
  }

  .img-4 {
    background-image: url("../assets/4.jpg");
  }

  .img-5 {
    background-image: url("../assets/5.jpg");
  }
}

.el-carousel__indicators {
  width: 100%;
}
</style>
